// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-item-text {
  color: #dedcdc;
  font-size: 1rem;
  flex-shrink: 1;
  align-self: center;
}

.menu-header-item-icon {
  color: #dedcdc;
  font-size: 17px;
  font-family: Inter !important;
  align-self: center;
  vertical-align: middle;
  font-weight: bold;
}

.accordian-button-text {
  color: white !important;
  font-size: 18px !important;
  font-weight: normal !important;
  height: -moz-fit-content;
  height: fit-content;
  min-height: 24px;
}

.organisation-suspended::after {
  content: " (suspended)";
}

::ng-deep .card-header {
  padding-left: 5px !important;
  padding-right: 5px !important;
}

::ng-deep .card-body {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  padding-right: 0 !important;
  padding-left: 15px !important;
}

.menu-header-item-text {
  color: var(--theme-active-alternate-color, #dedcdc);
  font-size: 17px;
  font-family: Inter !important;
  align-self: center;
  vertical-align: middle;
  font-weight: bold;
  margin-left: 10px;
}

.icon-gap {
  margin-left: 10px;
  display: flex;
  height: 100%;
  min-height: 0;
  align-self: baseline;
}

.vertical-align {
  margin-bottom: 10px !important;
  margin-top: 10px !important;
}

.vertical-align-search-row {
  text-align: center;
  margin: auto;
}

.header-row {
  border-bottom: 1px solid rgb(236, 236, 236);
  align-content: center;
  padding-left: 10px;
  flex-basis: 64px;
  min-height: 70px;
}

.logo-background-color {
  background-color: var(--theme-logo-background-color, #055C8D);
}

.instruction-row {
  padding-top: 20px;
  padding-right: 15px !important;
  padding-left: 15px;
  flex-basis: 32px;
}

.nav-pane-text {
  font-size: 14px;
  font-style: italic;
}

.menu-heading {
  font-size: 16px;
  padding-top: 5px;
  padding-left: 6px;
  font-weight: 600;
}

hr.solid {
  border-top: 1px solid #ececec;
  width: 100%;
  opacity: 1;
}

.select-municipality-row {
  padding-top: 5px;
  padding-right: 5px;
  padding-left: 5px;
  flex-basis: 32px;
}

.select-labels-padding {
  padding-bottom: 2px;
  padding-left: 6px;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
}

.view-documentation-row {
  padding-right: 5px;
  padding-left: none;
}

.create-application-row {
  margin-top: 10px;
  padding-top: 10px;
  padding-right: 5px;
  padding-left: none;
}

.link-text {
  cursor: pointer;
  color: #fff;
  font-size: 15px !important;
  padding-left: 2px;
  padding-right: 2px;
  font-style: normal;
  transition: none;
  text-decoration: none;
}

.link-textcreatenew {
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  padding-left: 1px;
}

.linktextcreateapplication {
  border-top: #fff;
  border-style: solid;
  border-width: 1px;
}

.searchButton {
  position: left;
  width: 2vw;
  height: 30px;
  border: none;
  background: none;
  text-align: center;
  margin-left: 7px;
  color: #fff;
  cursor: pointer;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  font-size: 15px;
}

.searchButton:hover {
  width: 2vw;
  height: 30px;
  border: none;
  background: none;
  text-align: center;
  margin-left: 6px;
  color: #fff;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  font-size: 15px;
}

.search-my-application-row {
  display: flex;
  align-items: center;
  margin-bottom: -11px;
  padding: 0;
  border-top: 1px solid #fff;
  width: 100%;
  max-width: 500px;
  box-sizing: border-box;
  margin-left: auto;
  margin-right: auto;
  transition: none;
}

.settings-div {
  padding-top: 0.5px !important;
  padding-left: 5px !important;
}

.add-organisation-row {
  margin-top: auto;
  border-top: 1px solid rgb(236, 236, 236);
  padding-right: 5px;
  flex-basis: 32px;
  min-height: 32px;
}

.logout-row {
  border-top: 1px solid #fff;
  padding-top: 5px;
  padding-bottom: 0px;
  justify-content: space-between;
  padding-right: 0.3vw;
  padding-left: 0.3vw;
  max-height: 32px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0;
}

.mb-3 {
  margin-bottom: 10px !important;
}

.p-2 {
  padding-top: 0px !important;
}

.menu-row {
  flex-shrink: 1;
  flex-grow: 1;
  padding-left: 5px;
  padding-right: 5px;
}

.add-organisation-link {
  text-align: center;
  color: white;
  cursor: pointer;
}

.search-application-link-text {
  text-align: center;
  color: white;
  cursor: pointer;
  transition: none;
  margin-left: 10px;
}

.logout-link {
  text-decoration: none;
  text-align: center;
  color: var(--theme-main-color, #055C8D);
  cursor: pointer;
  font-size: 13px;
  background-color: #fff;
  padding-top: 3.5px;
  padding-bottom: 7px;
  margin-bottom: 3px;
  padding-left: 4.5vw;
  padding-right: 6.1vw;
  border: 1px;
  border-color: #fff;
  border-style: solid;
  border-radius: 8px;
  max-width: 300px;
  box-sizing: border-box;
  border: 1px solid #fff;
  width: auto;
}

.logout-link:hover {
  text-decoration: none;
  text-align: center;
  color: #fff;
  cursor: pointer;
  font-size: 13px;
  background-color: var(--theme-active-color, #055C8D);
  padding-top: 4.5px;
  padding-bottom: 7px;
  margin-bottom: 3px;
  transform: none;
  padding-left: 4.5vw;
  padding-right: 6.1vw;
  border: 1px;
  border-color: #fff;
  border-style: solid;
  border-radius: 8px;
  max-width: 300px;
  box-sizing: border-box;
  border: 1px solid #fff;
  width: auto;
}

.settings-link {
  text-decoration: none;
  text-align: left;
  color: var(--theme-main-color, #055C8D);
  cursor: pointer;
  font-size: 13px;
  background-color: #fff;
  padding-top: 3px;
  padding-bottom: 4px;
  margin-bottom: 1px;
  padding-left: 1.5vw;
  padding-right: 1.5vw;
  border: 1px;
  border-color: #fff;
  border-style: solid;
  border-radius: 8px;
}

.settings-link:hover {
  text-decoration: none;
  text-align: left;
  color: #fff;
  cursor: pointer;
  font-size: 13px;
  background-color: var(--theme-main-background-color, #055C8D);
  padding-top: 3px;
  padding-bottom: 4px;
  margin-bottom: 1px;
  padding-left: 1.5vw;
  padding-right: 1.5vw;
  border: 1px;
  border-color: #fff;
  border-style: solid;
  border-radius: 8px;
}

.content-panel {
  overflow-y: auto;
  min-height: 0;
}

.settings-icon {
  color: white;
}

.icon-button {
  padding: 0;
  min-width: 0;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  line-height: 20px;
  border-radius: 50%;
  color: white;
}

.las {
  font-size: 17px;
  padding-top: 5px !important;
}

.organisation-modules-settings {
  height: 93%;
  overflow-x: hidden;
  overflow-y: scroll;
}

.menu-item {
  padding-left: 28px;
}

.organisation-line {
  color: white;
  background-color: white;
  width: 100%;
}

.bottom-group {
  position: absolute;
  bottom: 4%;
  width: 229.63px;
}

.bottom-group-line {
  background-color: white;
  width: 100%;
}

.link-spacer {
  margin-top: 1%;
  margin-bottom: 1%;
}

.row-item {
  padding-top: 15px;
  padding-bottom: 15px;
}

.padded-menu-item {
  padding-left: 5%;
}

.icon {
  color: white;
  float: right;
}

.menu-item-module {
  padding-left: 40px;
}

.tool-map {
  bottom: 1%;
  position: absolute;
  width: 100%;
}

.keyboard-backspace {
  vertical-align: top;
  color: white;
}

.organisation-setting-icon {
  display: none;
  width: 10%;
}

.organisation-setting-label {
  font-weight: bold;
  padding-right: 0;
  padding-left: 0;
}

.user-organisations {
  overflow-y: scroll;
  height: 40%;
}

.module-item {
  width: 85%;
  margin-left: 5%;
}

.icon-button {
  cursor: pointer;
  font-size: 20px;
  vertical-align: middle;
}

.icon-header-button {
  cursor: pointer;
  font-size: 26px;
  vertical-align: middle;
}

.dropdown-content {
  display: block;
  position: absolute; /* new */
  width: 100%; /* new */
}

.module-item-icon-column {
  flex-basis: 24px;
  min-width: 24px;
  max-width: 24px;
}

.module-item-column {
  flex-shrink: 1;
  flex-grow: 1;
  cursor: pointer;
}

.add-org {
  padding-left: 5px;
}

.module-suspended::after {
  content: " (suspended)";
}

.select-application {
  margin: 1px !important;
}

.form-select {
  padding: 0.5rem 2.25rem 0.375rem 0.75rem !important;
  width: 92% !important;
  margin-left: 10px !important;
}

.hiddenmenu-row {
  padding-bottom: 8px;
  border-bottom: #ececec;
  margin-left: 2px;
  margin-right: 2px;
  border-style: solid;
  border-width: 1px;
  color: var(--theme-main-color, #055C8D);
}

.search-my-application-row {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0;
  border-top: 1px solid #fff;
  box-sizing: border-box;
  transition: none;
}

.search-my-application-row .searchButton {
  margin-right: 4px;
}

.link-text {
  line-height: 1.5;
  margin-left: 4px;
}

@media (max-width: 1320px) {
  .search-my-application-row {
    justify-content: center;
  }
  .searchButton {
    position: left;
    width: 2vw;
    height: 30px;
    border: none;
    background: none;
    text-align: center;
    margin-left: 26px;
    color: #fff;
    cursor: pointer;
    border-radius: 0 5px 5px 0;
    cursor: pointer;
    font-size: 15px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
